export default(function(){$('.copyright-year').text("".concat(new Date().getFullYear()));});